import * as React from "react";
import type { SVGProps } from "react";
const Linkedin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22.2857 0H1.7089C.7661 0 0 .7768 0 1.7304v20.5392C0 23.2232.766 24 1.709 24h20.5767C23.2286 24 24 23.2232 24 22.2696V1.7304C24 .7768 23.2286 0 22.2857 0M7.2536 20.5714H3.6964V9.1179H7.259v11.4535zM5.475 3.4286a2.0625 2.0625 0 1 1 0 4.125 2.0625 2.0625 0 0 1 0-4.125m15.1125 17.1428h-3.5571V15c0-1.3286-.0268-3.0375-1.8483-3.0375-1.8535 0-2.1375 1.4464-2.1375 2.9411v5.6678H9.4875V9.1179H12.9v1.5642h.0482c.4768-.9 1.6393-1.8482 3.3697-1.8482 3.6 0 4.2696 2.3732 4.2696 5.459z"
    />
  </svg>
);
export default Linkedin;
